export default __webpack_public_path__ + "static/media/Snd_TryD.292e1d5b.mp3";